/**
 * Bootstrap 5 tooltips: init after full page load or AJAX-inserted markup.
 * Uses getOrCreateInstance so repeated calls on the same node are safe.
 */
function resolveElement(root) {
  if (!root) return document;
  if (root.jquery && root.length) return root[0];
  if (root.nodeType === 1) return root;
  return document;
}

export function initBootstrapTooltips(root) {
  const bootstrap = window.bootstrap;
  if (!bootstrap || typeof bootstrap.Tooltip !== "function") return;

  const el = resolveElement(root);
  el.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((triggerEl) => {
    bootstrap.Tooltip.getOrCreateInstance(triggerEl);
  });
}

export function initBootstrapDropdowns(root) {
  const bootstrap = window.bootstrap;
  if (!bootstrap || typeof bootstrap.Dropdown !== "function") return;

  const el = resolveElement(root);
  el.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((triggerEl) => {
    const existing = bootstrap.Dropdown.getInstance(triggerEl);
    if (existing) existing.dispose();
    bootstrap.Dropdown.getOrCreateInstance(triggerEl, {
      popperConfig: { strategy: "fixed" },
    });
  });
}

export function initBootstrapComponents(root) {
  initBootstrapTooltips(root);
  initBootstrapDropdowns(root);
}

/** Call from turbolinks:before-cache so cached snapshots do not keep floating tip nodes. */
export function disposeBootstrapTooltipsIn(root) {
  const bootstrap = window.bootstrap;
  if (!bootstrap || typeof bootstrap.Tooltip !== "function") return;

  const el = resolveElement(root);
  el.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((triggerEl) => {
    const instance = bootstrap.Tooltip.getInstance(triggerEl);
    if (instance) instance.dispose();
  });
}
